import { ColDef, ColGroupDef } from "ag-grid-community"

export const CUBE_KEY = process.env.REACT_APP_CUBE_KEY
export const CUBE_API = process.env.REACT_APP_CUBE_API

export const DEFAULT_CUBE_PAGE_LIMIT = 1e2
export const MAX_CUBE_PAGE_LIMIT = 1e4
export const DEFAULT_SCROLL_DEBOUNCE = 1e3

export const OPERATOR_MAP = {
  default: {
    equals: "equals",
    notEqual: "notEquals",
    lessThan: "lt",
    lessThanOrEqual: "lte",
    greaterThan: "gt",
    greaterThanOrEqual: "gte",
    blank: "notSet",
    notBlank: "set",
  },
  date: {
    inRange: "inDateRange",
    lessThan: "beforeDate",
    greaterThan: "afterDate",
  },
}

export type GroupOrColDef = Partial<ColDef> & Partial<ColGroupDef>
